import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAllPackages, numberWithCommas, numberWithAbbr } from "../constants";

const SubscriptionPlan = ({
  setStep,
  setTotalPrice,
  setType,
  qty,
  setQty,
  setPackageIntervalId,
  setCouponCode,
}) => {
  const user = JSON.parse(localStorage.getItem("user_info"));
  const token = user.access_token;
  const [priceCard, setPriceCard] = useState(0);
  const [dataPackages, setDataPackages] = useState([
    {
      package_id: "PKG118ad3d73e3847eca678d18d762d7781",
      package_interval_id: "PKVb1de8df9166f4867b14ca6a76343f989",
      interval_month: 1,
      base_price: "20000.00",
      currency: "IDR",
      is_active: true,
      created_at: "2025-08-13T03:59:02.398981+00:00",
      updated_at: "2025-08-13T03:59:02.398981+00:00",
      coupon: null,
    },
    {
      package_id: "PKG118ad3d73e3847eca678d18d762d7781",
      package_interval_id: "PKV035225dce16c4e9f82f8c07590cd8826",
      interval_month: 3,
      base_price: "60000.00",
      currency: "IDR",
      is_active: true,
      created_at: "2025-08-13T03:59:03.446427+00:00",
      updated_at: "2025-08-13T03:59:03.446427+00:00",
      coupon: {
        coupoon_id: "CPN5184b780bce240dda5e03c8ad7e86d8e",
        code: "nitomeyo3",
        discount_type: "AMOUNT",
        discount_value: "3000.00",
        currency: "IDR",
        start_at: null,
        expires_at: null,
      },
    },
    {
      package_id: "PKG118ad3d73e3847eca678d18d762d7781",
      package_interval_id: "PKVfb98b0b9703842e2a09f1a6e88180cc3",
      interval_month: 6,
      base_price: "120000.00",
      currency: "IDR",
      is_active: true,
      created_at: "2025-08-13T03:59:04.424909+00:00",
      updated_at: "2025-08-13T03:59:04.424909+00:00",
      coupon: {
        coupoon_id: "CPN70220dad5da44dac85cbb62b633c8f75",
        code: "nitomeyo6",
        discount_type: "AMOUNT",
        discount_value: "18000.00",
        currency: "IDR",
        start_at: null,
        expires_at: null,
      },
    },
    {
      package_id: "PKG118ad3d73e3847eca678d18d762d7781",
      package_interval_id: "PKV3af27825dfa94e1dad9721d684cc185f",
      interval_month: 12,
      base_price: "240000.00",
      currency: "IDR",
      is_active: true,
      created_at: "2025-08-13T03:59:05.553348+00:00",
      updated_at: "2025-08-13T03:59:05.553348+00:00",
      coupon: {
        coupoon_id: "CPN0197a16e2c5c42a69757fc69045e8ecb",
        code: "nitomeyo12",
        discount_type: "AMOUNT",
        discount_value: "72000.00",
        currency: "IDR",
        start_at: null,
        expires_at: null,
      },
    },
    {
      package_id: "PKG118ad3d73e3847eca678d18d762d7781",
      package_interval_id: "PKVb274aa0a0ddd4e5a9539debcc0e75831",
      interval_month: 120,
      base_price: "599999.00",
      currency: "IDR",
      is_active: true,
      created_at: "2025-08-13T03:59:06.617858+00:00",
      updated_at: "2025-08-13T03:59:06.617858+00:00",
      coupon: null,
    },
  ]);
  const [qtyMonth, setQtyMonth] = useState(1);
  const [qtyYear, setQtyYear] = useState(1);
  const navigate = useNavigate();

  useEffect(() => {
    if (priceCard == 0) {
      setQty(1);
      setTotalPrice(parseInt(dataPackages[0].base_price));
      setType("1 Month");
      setCouponCode(null);
    } else if (priceCard == 1) {
      setQty(3);
      setTotalPrice(
        parseInt(dataPackages[priceCard].base_price) -
          parseInt(dataPackages[priceCard].coupon.discount_value)
      );
      setType("3 Months");
      setCouponCode(dataPackages[priceCard].coupon.code);
    } else if (priceCard == 2) {
      setQty(6);
      setTotalPrice(
        parseInt(dataPackages[priceCard].base_price) -
          parseInt(dataPackages[priceCard].coupon.discount_value)
      );
      setType("6 Months");
      setCouponCode(dataPackages[priceCard].coupon.code);
    } else if (priceCard == 3) {
      setQty(12);
      setTotalPrice(
        parseInt(dataPackages[priceCard].base_price) -
          parseInt(dataPackages[priceCard].coupon.discount_value)
      );
      setType("1 Year");
      setCouponCode(dataPackages[priceCard].coupon.code);
    } else {
      setQty("infinity");
      setTotalPrice(parseInt(dataPackages[priceCard].base_price));
      setType("Life times");
      setCouponCode(null);
    }
    setPackageIntervalId(dataPackages[priceCard].package_interval_id);
  }, [qty, priceCard]);

  useEffect(() => {
    setPackageIntervalId(dataPackages[0].package_interval_id);
    getAllPackages(token, setDataPackages);
  }, []);

  return (
    <div className="flex flex-col w-full h-full justify-between items-start bg-white text-black p-8 gap-10">
      <div className="flex flex-col w-full gap-5 h-full">
        <div className="hidden md:flex text-[32px] font-bold">
          Subscription Plan - Upgrade to Individual
        </div>
        <div className="grid grid-cols-1 w-full justify-between h-full gap-5 md:gap-0">
          <div
            className={`flex flex-row justify-between rounded-lg  items-center border w-full h-fit px-8 py-2 gap-5 hover:border-primary cursor-pointer ${
              priceCard == 0 ? "border-primary" : ""
            }`}
            onClick={() => setPriceCard(0)}
          >
            <div className="text-[17px] md:text-[22px] font-bold">
              {dataPackages[0].interval_month} Month
            </div>
            <div className="text-[20px] md:text-[32px]">
              {dataPackages[0].currency}{" "}
              {numberWithCommas(parseInt(dataPackages[0].base_price))}
            </div>
          </div>
          <div
            className={`flex flex-col rounded-lg items-center border w-full h-fit hover:border-primary bg-secondary text-white cursor-pointer pb-3 md:pb-0 ${
              priceCard == 1 ? "border-primary" : ""
            }`}
            onClick={() => setPriceCard(1)}
          >
            <div className="flex flex-col justify-start w-full bg-blue-600 py-1 px-8 rounded-t-lg font-bold">
              Most popular
            </div>
            <div className="flex flex-row w-full justify-between px-8 py-2">
              <div className="flex flex-row items-center gap-10 text-[17px] md:text-[22px] font-bold">
                {dataPackages[1].interval_month} Months
                <span className="hidden md:flex font-bold py-1 px-2 rounded-lg text-[12px] text-white bg-green-600">
                  Only IDR{" "}
                  {numberWithAbbr(
                    (parseInt(dataPackages[1].base_price) -
                      parseInt(dataPackages[1].coupon.discount_value)) /
                      dataPackages[1].interval_month
                  )}{" "}
                  per month
                </span>
              </div>
              <div className="flex flex-row gap-5 items-center text-[20px] md:text-[32px]">
                {dataPackages[1].currency}{" "}
                {numberWithCommas(
                  parseInt(dataPackages[1].base_price) -
                    parseInt(dataPackages[1].coupon.discount_value)
                )}
              </div>
            </div>
            <span className="flex md:hidden font-bold py-1 px-2 rounded-lg text-[12px] text-white bg-green-600">
              Only IDR{" "}
              {numberWithAbbr(
                (parseInt(dataPackages[1].base_price) -
                  parseInt(dataPackages[1].coupon.discount_value)) /
                  dataPackages[1].interval_month
              )}{" "}
              per month
            </span>
          </div>
          <div
            className={`flex flex-col justify-between rounded-lg  items-center border w-full h-fit px-8 py-2 hover:border-primary cursor-pointer ${
              priceCard == 2 ? "border-primary" : ""
            }`}
            onClick={() => setPriceCard(2)}
          >
            <div className="flex flex-row w-full justify-between py-2">
              <div className="flex flex-row items-center gap-10 text-[17px] md:text-[22px] font-bold">
                {dataPackages[2].interval_month} Months
                <span className="hidden md:flex font-bold py-1 px-2 rounded-lg text-[12px] text-white bg-green-600">
                  Only IDR{" "}
                  {numberWithAbbr(
                    (parseInt(dataPackages[2].base_price) -
                      parseInt(dataPackages[2].coupon.discount_value)) /
                      dataPackages[2].interval_month
                  )}{" "}
                  per month
                </span>
              </div>
              <div className="flex flex-row gap-5 items-center text-[20px] md:text-[32px]">
                {dataPackages[2].currency}{" "}
                {numberWithCommas(
                  parseInt(dataPackages[2].base_price) -
                    parseInt(dataPackages[2].coupon.discount_value)
                )}
              </div>
            </div>
            <span className="flex md:hidden font-bold py-1 px-2 rounded-lg text-[12px] text-white bg-green-600">
              Only IDR{" "}
              {numberWithAbbr(
                (parseInt(dataPackages[2].base_price) -
                  parseInt(dataPackages[2].coupon.discount_value)) /
                  dataPackages[2].interval_month
              )}{" "}
              per month
            </span>
          </div>
          <div
            className={`flex flex-col rounded-lg  items-center border w-full h-fit hover:border-primary bg-secondary text-white cursor-pointer pb-3 md:pb-0 ${
              priceCard == 3 ? "border-primary" : ""
            }`}
            onClick={() => setPriceCard(3)}
          >
            <div className="flex flex-col justify-start w-full bg-yellow-300 py-1 px-8 rounded-t-lg font-bold text-black">
              Recommended
            </div>
            <div className="flex flex-row w-full justify-between px-8 py-2">
              <div className="flex flex-row items-center gap-10 text-[17px] md:text-[22px] font-bold">
                {dataPackages[3].interval_month} Months
                <span className="hidden md:flex font-bold py-1 px-2 rounded-lg text-[12px] text-white bg-green-600">
                  Only IDR{" "}
                  {numberWithAbbr(
                    (parseInt(dataPackages[3].base_price) -
                      parseInt(dataPackages[3].coupon.discount_value)) /
                      dataPackages[3].interval_month
                  )}{" "}
                  per month
                </span>
              </div>
              <div className="flex flex-row gap-5 items-center text-[20px] md:text-[32px]">
                {dataPackages[3].currency}{" "}
                {numberWithCommas(
                  parseInt(dataPackages[3].base_price) -
                    parseInt(dataPackages[3].coupon.discount_value)
                )}
              </div>
            </div>
            <span className="flex md:hidden font-bold py-1 px-2 rounded-lg text-[12px] text-white bg-green-600">
              Only IDR{" "}
              {numberWithAbbr(
                (parseInt(dataPackages[3].base_price) -
                  parseInt(dataPackages[3].coupon.discount_value)) /
                  dataPackages[3].interval_month
              )}{" "}
              per month
            </span>
          </div>
          <div
            className={`flex flex-row justify-between rounded-lg  items-center border w-full h-fit px-8 py-2 gap-5 hover:border-primary cursor-pointer ${
              priceCard == 4 ? "border-primary" : ""
            }`}
            onClick={() => setPriceCard(4)}
          >
            <div className="text-[17px] md:text-[22px] font-bold">
              Life Time
            </div>
            <div className="flex flex-row gap-5 items-center text-[20px] md:text-[32px]">
              {dataPackages[4].currency}{" "}
              {numberWithCommas(parseInt(dataPackages[4].base_price))}
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-row justify-between items-center w-full gap-20 md:gap-0">
        <div
          className="flex text-center w-[200px] py-2 border border-primary text-primary items-center justify-center rounded-md shadow-lg cursor-pointer"
          onClick={() => navigate("/")}
        >
          Back
        </div>
        <div
          className="flex text-center w-[200px] py-2 border bg-primary text-white items-center justify-center rounded-md shadow-lg cursor-pointer"
          onClick={() => setStep(2)}
        >
          Next
        </div>
      </div>
    </div>
  );
};

export default SubscriptionPlan;
